module.exports = __webpack_public_path__ + "static/roots-small-e03b8e1dfb9aac3a324de1ba9619df07.png";